<!-- 公服企业办理表格 -->
<template>
    <div class='tablebox box box_v'>
        <div class="box contentbox">
            <div class="w4 title">企业名称</div>
            <div class="w3 title">待办</div>
            <div class="w3 title">已办</div>
        </div>
        <div class="nodataBox box_f1" v-if="nodata">暂无数据</div>
        <div class="box_f1 box contentbox" v-for="(item,index) in companydata" :key="index" v-else>
            <div class="w4">{{item.companyName}}</div>
            <div class="w3 organ">{{item.todocount}}</div>
            <div class="w3">{{item.donecount}}</div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            companydata:[],
            nodata:false,
        };
    },
  props:{
    token:{
      type:String,
      default: ''
    }
  },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            var url = this.urlobj.getCompany('event')
            this.$get(url,{},{
              token:this.token || this.$store.state.access_token
            }).then(res => {
                if (res.isSucceed) {
                  var data = []
                  for (var i=0;i<res.rows[0].xaxis.length;i++) {
                    data.push({
                      companyName:res.rows[0].xaxis[i],
                      todocount : res.rows[0].series[0].data[i],
                      donecount : res.rows[0].series[1].data[i]
                    })
                  }



                  // res.rows[0].xaxis.forEach((item,index) => {
                  //   data[index].companyName = item
                  // })
                  // res.rows[0].series[0].data.forEach((item,index) => {
                  //   data[index].todocount = item
                  // })
                  // res.rows[0].series[1].data.forEach((item,index) => {
                  //   data[index].donecount = item
                  // })

                    if(!data.length){
                        this.nodata = true;
                        return
                    }

                    data.sort(this.$util.compare('todocount'))
                    this.companydata = data.length>4?data.slice(0,4):data
                } else {

                }
            }).catch(e => {

            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.tablebox{
    font-size: 12px;
    color:#b0b0b0;
    height: 100%;
}
.contentbox{
    width: 100%;
    align-items: center;
    // justify-content: space-around
}
.w4{
    width: 40%;
    text-align: center;
}
.w3{
    width: 30%;
    text-align: center;
}
.title{
    color:#91b1fc;

}
.organ{
    color:#f6ab00;
}
.nodataBox{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #b0b0b0;
}
</style>
